import { AxiosInstance } from "axios";
import { Notification_UserEntity } from "../../domain/entities";
import { ModelClient } from "../ModelClient";

export class Notification_UserClient extends ModelClient<Notification_UserEntity> {

  constructor(apiClient: AxiosInstance) {
    super(apiClient, 'Notification_User')
  }
}